import { WellDetailsStates } from 'business/models/CustomModels';
import { ImageFocusLevelDTO } from 'business/models/Models';
import { EFetchingStatus } from 'enums/EFetchingStatus';

export enum WellsLayoutType {
  Grid,
  Row,
}

export enum WellDisplayMode {
  Drop = 'drop',
  Compare = 'compare',
  Well = 'well',
}

export enum DrawingIcon {
  Crosshair = 'crosshair',
  Default = 'default',
}
export type DropDetails = {
  expId: number;
  plateID: number;
  wellNum: number;
  dropNumber: number;
  dropId: number;
  cpID: number;
  imageBatchId: number;
  regionID: number;
  regionName: string;
  rowNumber: number;
};

export interface ImageSizeDetails {
  width: number;
  height: number;
  wellDetails: WellDetailsStates | DropDetails;
  scalingWidth: number;
  scalingHeight: number;
}

export const wellsVerticalPadding = 10;
export const wellsHorizontalPadding = 20;
export const containerRows = 8;
export const containerCols = 12;
export const scaleBarHeight = 40;
export const scaleBarGroupWidth = 160;
export const scaleBarWidth = scaleBarGroupWidth * 0.35;

export const defaultLowerLevelLimit = 0;
export const defaultUpperLevelLimit = 255;
export const DEFAULT_FONT_FAMILY = 'Microsoft Sans Serif'; // as per v3
export const DEFAULT_FONT_SIZE = 8; // as per v3
export const DEFAULT_DRAWING_COLOR = { r: 74, g: 144, b: 226 };
export const DEFAULT_POI_COLOR = { r: 74, g: 144, b: 226 };

export type FocusLevelImagesData = {
  status: EFetchingStatus;
  data: ImageFocusLevelDTO[];
};
